import { Link } from "react-router-dom";

/** Satu area banner = satu link. Tujuan internal di tab yang sama, link luar di tab baru. */
export function BannerLink({ href, children, className, tid, onClickCapture }) {
  if (!href) return <div className={className} data-testid={tid}>{children}</div>;
  const internal = href.startsWith("/");
  if (internal) {
    return (
      <Link to={href} className={className} data-testid={tid} onClickCapture={onClickCapture}>
        {children}
      </Link>
    );
  }
  return (
    <a href={href} target="_blank" rel="noopener noreferrer" className={className} data-testid={tid} onClickCapture={onClickCapture}>
      {children}
    </a>
  );
}
